<template>
  <div class="buy-member-container">
    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="超级会员"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />
    <div class="main-container" v-show="!offerState">
      <div class="person-message">
        <div class="user-photo">
          <img :src="userData.avatar_url" alt="" />
          <img
            class="member-icon"
            src="https://files.wondercv.com/m/buyMember/person_is_super1.png"
            alt=""
            v-if="isSuper"
          />
        </div>
        <div class="user-message">
          <div class="name" :class="isSuper && 'member-color'">
            <span>{{ userData.username }}</span>
            <!-- <img src="https://files.wondercv.com/m/buyMember/person_is_super1.png" alt="" v-if="isSuper"> -->
            <!-- <img src="https://files.wondercv.com/m/buyMember/person_not_super.png" alt="" v-else> -->
            <div
              class="member-privilege"
              v-if="isSuper"
              @click="togglePrivilegePopup(true)"
            >
              我的权益
            </div>
          </div>
          <div class="expiry" :class="isSuper && 'member-color'">
            {{ userData.membership_expired_at | personTimeFilter }}
          </div>
        </div>
      </div>
      <div class="member-container">
        <div class="list-wrapper">
          <div
            v-for="(item, index) in member_type"
            class="item"
            :key="index"
            data-growing-container
            @click="changeType(item, index)"
            :class="{
              active: item.cent === activeObj.cent,
            }"
          >
            <div v-if="item.recommend" class="recommend-tips">{{ item.recommend }}</div>
            <div class="text">{{ item.text }}</div>
            <div class="cent">
              <span>￥</span>
              {{ item.deduction ? ((item.cent * 10 - (amountOfDeduction[purchaseRecordData.state] || 0) * 10) / 10) : item.cent }}
            </div>
            <div v-if="item.del" class="del">￥{{ item.del }}</div>
            <div class="member-tip-text">
              {{ item.tips }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="member-text">
        <span class="member-type">{{ activeObj.text }}：</span>
        <span class="member-adv">{{ activeObj.message }}</span>
      </div> -->
      <div class="rights-item">
        <div class="recommend-final-vip-layout"> 超级硬核 </div>
        <div class="intro-wrapper">
          <cube-checkbox :value="hasRights" shape="square" @input="handleUpdateRights"></cube-checkbox>
          <div class="intro-container">
            <div class="intro-content">
              <span class="title">{{ rightsPriceData.title }}</span>
              <span class="detail-btn" @click="rightsDetailState = true">详情</span>
            </div>
            <div class="intro-desc">解决99%的求职难题</div>
          </div>
        </div>
        
        <div class="price-intro">
          <div class="real-price">
            <span class="rmb-symbol">¥</span>
            <span class="number">{{ rightsPriceData.display }}</span>
          </div>
          <div class="original">¥{{ rightsPriceData.original }}</div>
        </div>
      </div>
      <!--优惠券相关-->
      <div class="special-offer" @click="goToSpecialOffer">
        <span class="use-coupon">优惠券</span>
        <div class="no-coupon">
          <span v-if="!activeCoupon.id">不使用优惠券</span>
          <span v-else-if="activeCoupon.id" style="color: #ff6644"
            >-￥{{ discounts }}</span
          >
          <span v-else-if="specialOfferList.length === 0">无可用优惠券</span>
          <span class="iconfont iconchevron-right"></span>
        </div>
      </div>
      <div class="price-box">
        <div class="item">
          <span>会员原价</span>
          <span>￥{{ (activeObj.cent * 10 - deductionPrice * 10) / 10 }}</span>
        </div>
        <div class="item">
          <span>2周Offer秘籍</span>
          <span>￥{{ hasRights && activeOption !== 0 ? rightsPriceData.real : 0 }}</span>
        </div>
        <div class="item">
          <span>优惠券</span>
          <span>-￥{{ discounts }}</span>
        </div>
      </div>
      <div class="total-price">
        <span>实付金额：</span>
        <span class="money">￥{{ money }}</span>
      </div>
      <div class="member-equity-title">会员权益</div>
      <div class="member-equity flex">
        <div
          class="member-item flex"
          v-for="(item, index) in memberships"
          :key="`membership_item_${index}`"
          :class="{'opacity-text': item[selectMemberType] === null}"
        >
          <img
            :src="item.icon"
            alt=""
            class="member-item-img"
          />
          <div class="desc-title">
            {{ `${item[selectMemberType] || ''}${item.title}` }}
          </div>
          <div class="desc-description">
            {{ item.description }}
          </div>
        </div>
      </div>
      <div class="member-explain">
        <div class="title">会员说明</div>
        <p class="item">1. 从购买后立刻开始生效，享有超级会员所有特权</p>
        <p class="item">2. 使用期间可随时续费，有效期将直接累加</p>
        <p class="item">3. 会员过期后仅可使用免费功能</p>
        <p class="item">4. 可在我的订单中查看购买记录和时间</p>
        <p class="item">
          5. 最终解释权归超级简历所有，如有疑问，请联系在线客服
        </p>
      </div>
    </div>
    <div class="member-footer">
      <div class="submit-btn" @click="goToPay">
        <span
          v-if="[1, 2, 4].includes(purchaseRecordData.state)"
          class="positon-ab"
        >
          {{purchaseRecordData.state === 4 ? '升级终身立享40元优惠' : '终身首单限时10分钟特惠'}}
          <span class="triangle"></span>
        </span>
        {{ userData.is_membership ? "立即续费" : "立即开通" }}
      </div>
    </div>
    <template v-if="offerState">
      <special-offer
        :specialOfferList="couponList"
        :activeCoupon="activeCoupon"
        :activeObj="activeObj"
        @closeOffer="closeOffer"
      ></special-offer>
    </template>
    <w-dialog :dialog-show="aliPayMini" @handleClose="handleClose">
      <div slot="content" class="content flex-column-center" @touchmove.prevent>
        <img
          src="https://files.wondercv.com/mobile/orders/ios-dialog.png"
          alt=""
        />
        <p class="title">前往电脑端使用</p>
        <p class="message">
          电脑登录 <span class="high-light">wondercv.com</span
          ><br />购买超级会员
        </p>
        <ul class="description">
          <li v-for="(item, index) in descriptionInfo" :key="index">
            {{ item }}
          </li>
        </ul>
        <button class="theme-button flex-center">
          <!--          <span class="iconfont iconweixin1"></span>-->
          <span @click="handleClose">我知道了</span>
        </button>
        <p
          v-if="!isAlipayClient && !isUCClient && !isQuaReClient"
          class="pay-footer"
          @click="toUdesk"
        >
          咨询客服
        </p>
      </div>
    </w-dialog>

    <w-dialog name="scale" :top="30" :dialog-show="rightsDetailState" @handleClose="rightsDetailState = false">
      <img slot="content" class="rights-detail-image" src="https://logo.wondercv.com/banners/1EJNkbHWbDkFml7.png" alt="">
    </w-dialog>

    <WPopup
      v-if="privilegePopupVisible"
      :state="privilegePopupVisible"
      @handleClose="togglePrivilegePopup(false)"
    >
      <div class="privilege-box" slot="content">
        <!-- Title -->
        <h6 class="privilege-box-title">会员权益使用信息</h6>

        <!-- List -->
        <ul class="privilege-box-list">
          <li class="privilege-box-item">
            <span>可拥有简历份数</span>
            <span
              >{{ privilegeInfo.cv_count }}/{{
                privilegeInfo.cv_all_count
              }}</span
            >
          </li>
          <li class="privilege-box-item">
            <span>AI 智能检查</span>
            <span
              >{{ privilegeInfo.cv_check_count }}/{{
                privilegeInfo.cv_check_all_count
              }}</span
            >
          </li>
          <li class="privilege-box-item">
            <span>证件照极速制作一键导出</span>
            <span
              >{{ privilegeInfo.id_photo_count }}/{{
                privilegeInfo.id_photo_all_count
              }}</span
            >
          </li>
          <li class="privilege-box-item">
            <span>简历纠错</span>
            <span
              >{{ privilegeInfo.find_error_count }}/{{
                privilegeInfo.find_error_all_count
              }}</span
            >
          </li>
          <li class="privilege-box-item">
            <span>中英一键翻译</span>
            <span
              >{{ privilegeInfo.cv_trans_count }}/{{
                privilegeInfo.cv_trans_all_count
              }}</span
            >
          </li>
        </ul>

        <!-- Button -->
        <div class="privilege-box-btn" @click="togglePrivilegePopup(false)">
          我知道了
        </div>
      </div>
    </WPopup>
  </div>
</template>

<script>
import moment from "moment";
import Cookies from "js-cookie";
// vuex
import { mapState, mapActions } from "vuex";
// component
import WPopup from "@/components/global/w-popup";
import WNavbar from "@/components/global/w-navbar";
import WDialog from "@/components/global/w-dialog";
import SpecialOffer from "./components/special-offer";
// mixins
import { envMixin, loginMixin, WxMixin } from "@/assets/js/mixin/global";
import { componentsMixin } from "../../assets/js/mixin/components";
import { userMixin } from "@/assets/js/mixin/user";
// utils
import { toLogin } from "@/assets/js/utils";
import { MEMBER_PRICE_DATA } from "@/assets/js/constants";

const amountOfDeduction = {
  1: 20,
  2: 20,
  4: 40
}

export default {
  name: "buyMemberOrder",
  components: {
    WPopup,
    WNavbar,
    WDialog,
    SpecialOffer,
  },
  mixins: [envMixin, loginMixin, WxMixin, componentsMixin, userMixin],
  data() {
    return {
      privilegeInfo: {}, // 会员权益信息
      privilegePopupVisible: false, // 会员权益 popup
      amountOfDeduction,
      _t: "",
      toUrl: "/account/users/buy_member1",
      activeOption: 0,
      member_type: [
        {
          text: "终身会员",
          cent: MEMBER_PRICE_DATA.FOREVER,
          type: "终身会员",
          member: 'forever',
          del: 199,
          message: "终身无限享用 VIP 会员福利",
          tips: "终身享权益",
          recommend: '送Offer秘籍',
          deduction: true,
        },
        {
          text: "月度会员",
          cent: MEMBER_PRICE_DATA.MONTH,
          type: "超级会员",
          member: 'month',
          message: "1个月会员，平均每天 0.6 元",
          tips: "0.6元/日",
        },
        {
          text: "年度会员",
          cent: MEMBER_PRICE_DATA.YEAR,
          type: "超级会员",
          member: 'year',
          message: "12个月会员，限时优惠 每天 0.2 元",
          tips: "0.2元/日",
        },
      ],
      selectMemberType: 'forever',
      hasRights: true,
      rightsDetailState: false,
      rightsPriceData: {
        title: '2周Offer秘籍',
        real: 10,
        display: 39.9,
        original: 199
      },
      activeObj: {},
      money: "",
      offerState: false,
      isSuper: false,
      discounts: 0,
      activeCoupon: {},
      orderId: "",
      aliPayMini: false,
      couponList: [],
      descriptionInfo: [
        "享受超级简历所有特权",
        "AI 简历助手 智能改简历",
        "无限使用大牛模板案例",
        "帮你大幅提升求职成功率",
      ],
      memberships: [
        {
          title: "份简历",
          forever: '15',
          month: '5',
          year: '5',
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/many_resume_active.12b0af24.png',
          description: "满足更多岗位投递",
        },
        {
          title: "次检查",
          forever: '无限',
          month: '100',
          year: '1500',
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/detection.7fdaae03.png',
          description: "一键AI智能检查",
        },
        {
          title: "次简历翻译",
          forever: '无限',
          month: '10',
          year: '200',
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/cv_transition_active.596434cc.png',
          description: "中英一键转换",
        },
        {
          title: "海量模板",
          forever: '',
          month: '',
          year: '',
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/template_active.ce5f2861.png',
          description: "解锁所有专业模板",
        },
        {
          title: "专属社群",
          forever: '',
          month: '',
          year: '',
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/job_active.a8b083ae.png',
          description: "会员求职社群",
        },
        {
          title: "次简历纠错",
          forever: '100',
          month: '10',
          year: '10',
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/resume1_active.27c34434.png',
          description: "语义纠错完善细节",
        },
        {
          title: "次证件照制作",
          forever: '5',
          month: '1',
          year: '1',
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/image_active.e01a8276.png',
          description: "极速制作一键使用",
        },
        {
          title: "365天简历恢复",
          forever: '',
          month: null,
          year: null,
          icon: 'https://static.wondercv.cn/cv_pc_vue/img/resume_repair.50154749.png',
          description: "避免误删信息丢失",
        },
        {
          title: "专属客服",
          forever: '',
          month: null,
          year: null,
          icon: 'https://logo.wondercv.com/banners/PT8AP8Fkl2ZpUZE.png',
          description: "问题反馈优先解决",
        },
      ],
      purchaseRecordData: {
      },
    };
  },
  async mounted() {
    if (this.$route.params.from === "myPage") {
      this.toUrl = "/account/users/index";
    }
    window.scrollTo({
      top: 0,
      // instant ：瞬间滚动    smooth ：平滑滚动
      behavior: "instant",
    });
    this.getPurchaseRecordData();
    // 第一次进入默认获取终身会员的优惠券
    let data = { coupon_plan: "终身会员" };
    this.activeObj = this.member_type[0];
    // 获取能使用的优惠券
    await this.getSpecialOfferData({
      cv_account_token: this.cvAccountToken,
      data: data,
    });
    await this.getUserAccountInfo(this.cvAccountToken);
    this._t = Cookies.get("_t");
    if (!this._t) {
      toLogin(process.env.VUE_APP_HOST + "/buy/member/order");
    }
    let now = moment();
    let formatDate = moment(this.userData.membership_expired_at);
    let day = formatDate.diff(now, "day");
    // 是否会员
    if (!day || (day && day < 0)) {
      this.isSuper = false;
    } else {
      this.isSuper = true;
      this.getPrivilegeInfo();
    }

    // // cjz
    // this.isSuper = true
    // this.getPrivilegeInfo()

    // 第一次进入初始化（ 没有优惠券可使用时计算 money ）
    if (this.specialOfferList.length == 0) {
      this.money = (this.activeObj.cent * 10 + (this.hasRights && this.activeOption !== 0 ? 10 : 0) * 10 - this.deductionPrice * 10) / 10;
    }
  },
  methods: {
    // 获取优惠券
    ...mapActions("member", ["getSpecialOfferData"]),
    ...mapActions("user", ["getUserAccountInfo"]),
    async getPurchaseRecordData() {
      try {
        const { code, data } = await this.$api.user.getPurchaseRecordData();
        if (code === 1000) {
          this.purchaseRecordData = data;
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleUpdateRights() {
      try {
        if (this.activeOption === 0) {
          this.showToast('终身会员默认包含，不可取消', 1000)
        } else {
          this.hasRights = !this.hasRights;
          if (this.hasRights) {
            this.money = (+this.money * 10 + 10 * 10 - this.deductionPrice * 10) / 10
          } else {
            this.money = (+this.money * 10 - 10 * 10 - this.deductionPrice * 10) / 10
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getPrivilegeInfo() {
      try {
        let res = await this.$api.cv.getPrivilegeInfo(this.cvAccountToken);
        if (res.code === 1000) {
          this.privilegeInfo = res.data || {};
        }
      } catch (error) {
        console.log("获取 会员权益 错误：", error);
      }
    },

    togglePrivilegePopup(flag) {
      this.privilegePopupVisible = flag;
    },
    handleClose() {
      this.aliPayMini = false;
    },
    // 调取支付
    async goToPay() {
      if (this.isWechatBrowser || this.isWxMini || this.isHarmony) {
        let member_period;
        let isSuper = false;
        let isSuperPlus = false;
        switch (this.activeObj.cent) {
          case MEMBER_PRICE_DATA.MONTH:
            member_period = 1;
            break;
          case "45.00":
            member_period = 3;
            break;
          case MEMBER_PRICE_DATA.YEAR:
            member_period = 12;
            break;
          case MEMBER_PRICE_DATA.FOREVER:
            member_period = 1000;
            isSuper = true;
            break;
          case MEMBER_PRICE_DATA.WONDERPLUS:
            member_period = 2000;
            isSuper = true;
            isSuperPlus = true;
            break;
        }
        this.$db.ls.set("member_isSuper", isSuper);
        this.$db.ls.set("member_isSuperPlus", isSuperPlus);
        let res = await this.$api.user.createSuperOrder({ member_period, has_rights: JSON.stringify(this.hasRights) });
        let {
          code,
          data: { token },
        } = res;
        if (code === 1000) {
          this.orderId = token;
        } else {
          this.showToast(res.message, 1500);
        }
        if (parseInt(this.money) == 0 || this.isHarmony) {

          let buyMemberPayload = {
            coupon_id: this.activeCoupon.id,
          }

          if (this.isHarmony) buyMemberPayload.pay_type = 'app_alipay'

          let result = await this.$api.user.freeMoneyBuyMember(this.orderId, buyMemberPayload);
          
          if (result.code === 1000) {
            if (this.isHarmony && parseInt(this.money) !== 0) {
              // TODO: 增加鸿蒙支付
              console.log(result, 'result')
              window.harCallBack?.toPay?.(result.data.result)
            } else {
              this.showToast("购买成功", 1500);
              await this.getUserAccountInfo(this.cvAccountToken);
              setTimeout(() => {
                this.$router.push({
                  path: "/pay/wechat/success",
                  query: {
                    origin: "member",
                    activeOption: this.activeOption,
                    memberType: this.selectMemberType,
                    hasRights: this.hasRights ? '1' : '2'
                  },
                });
              }, 1500);
            }
          } else {
            this.showToast(JSON.stringify(result || {}))
          }
        } else {
          this.$router.push({
            path: "/pay/type",
            query: {
              type: "member",
              orderId: this.orderId,
              coupon_id: this.activeCoupon.id || "",
              memberType: this.selectMemberType,
              hasRights: this.hasRights ? '1' : '2'
            },
          });
        }
      } else {
        this.aliPayMini = true;
      }
    },
    // 调取客服
    async toUdesk() {
      let res = await this.$api.user.getUdeskOnlineUrl();
      window.location.href = res.data.udesk_online_url;
      // if(this.iosOrAndroid) {
      //   setupWebViewJavascriptBridge((bridge) => {
      //     bridge.callHandler('toCustomService',
      //       { url: res.data.udesk_online_url },
      //       function responseCallback (responseData) {
      //       })
      //   })
      // }
    },
    // 关闭优惠券页
    closeOffer(obj) {
      this.offerState = false;
      this.activeCoupon = obj.activeCoupon;
      this.couponList = obj.coupons;
    },
    // 打开优惠券兑换页面
    goToSpecialOffer() {
      this.offerState = true;
    },
    // 返回
    leftBtnClick() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        this.routeTo("/account/users/index");
      }
      // this.routeTo('/account/users/buy_member1')
      // this.routeTo(this.toUrl)
    },
    // 切换会员类型
    async changeType(obj, index) {
      this.activeObj = obj;
      this.activeOption = index;
      this.selectMemberType = obj.member;
      let data = { coupon_plan: obj.type };
      if (obj.type === "终身会员Plus") {
        data.coupon_plan = "终身会员";
      }
      if (index === 0) {
        this.hasRights = true
      }
      await this.getSpecialOfferData({
        cv_account_token: this.cvAccountToken,
        data: data,
      });
      if (this.specialOfferList.length == 0) {
        this.money = (obj.cent * 10 + (this.hasRights && this.activeOption !== 0 ? 10 : 0) * 10 - this.deductionPrice * 10) / 10;
      }
    },
  },
  watch: {
    specialOfferList: {
      deep: true,
      handler(newVal) {
        this.couponList = newVal;
      },
    },
    specialOffer: {
      deep: true,
      handler(newVal) {
        this.activeCoupon = newVal;
      },
    },
    activeCoupon: {
      deep: true,
      handler(newVal) {
        let totalPrice = parseInt(this.activeObj.cent) + (this.hasRights && this.activeOption !== 0 ? this.rightsPriceData.real : 0);
        let cent = newVal.cent;
        let discount = newVal.discount;
        if (cent) {
          this.money =
            totalPrice - cent / 100 > 0
              ? (totalPrice - cent / 100).toFixed(2)
              : (0).toFixed(2);
          this.discounts = (cent / 100).toFixed(2);
        } else if (discount) {
          this.money = ((totalPrice * 10 - totalPrice * (1 - discount) * 10 - this.deductionPrice * 10) / 10).toFixed(2);
          this.discounts = (totalPrice - totalPrice * discount).toFixed(2);
        } else {
          this.money = ((totalPrice * 10 - this.deductionPrice * 10) / 10).toFixed(2);
          this.discounts = "0.00";
        }
      },
    },
  },
  computed: {
    ...mapState("member", ["specialOfferList", "specialOffer"]),
    ...mapState("user", ["userData"]),
    deductionPrice() {
      const { deduction } = this.activeObj;
      return deduction ? (this.amountOfDeduction[this.purchaseRecordData.state] || 0) : 0;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global/variable";

.buy-member-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  .main-container {
    width: 100%;
    box-sizing: border-box;
    padding: 64px 20px 80px;
    .person-message {
      width: 100%;
      height: 88px;
      border-radius: 6px;
      box-sizing: border-box;
      padding: 24px;
      // background: url("https://files.wondercv.com/m/buyMember/person_message_back.png") no-repeat;
      background: url("https://files.wondercv.com/m/buyMember/member-bg.png")
        no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      .user-photo {
        position: relative;
        width: 44px;
        height: 44px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }

        .member-icon {
          width: 14px;
          height: 12px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
      .user-message {
        padding-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .name {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 500;
          color: #fff;
          img {
            width: 14px;
            height: 12px;
            object-fit: contain;
            margin-left: 8px;
          }
        }
        .expiry {
          color: rgba(255, 255, 255, 0.3);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 17px;
          padding-top: 7px;
        }
      }
    }
    .member-container {
      width: 100%;
      margin-top: 24px;
      .list-wrapper {
        height: 100% !important;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item {
          position: relative;
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          width: 100%;
          height: 145px;
          border-radius: 6px;
          background-color: #f9f9f9;
          margin-top: 11px;
          font-size: 14px;
          color: #606060;
          border: 1px solid #ececec;
          padding-top: 22px;
          box-sizing: border-box;
          &:not(:last-child) {
            margin-right: 16px;
          }
          .recommend-tips {
            position: absolute;
            left: 0;
            top: -12px;
            padding: 5px 8px;
            font-size: 12px;
            color: #fff;
            border-radius: 10px 0 10px 0;
            background: linear-gradient(to right, #FF6644, #FF915A);
          }
          .text {
            width: 100%;
            font-size: 14px;
            color: #404040;
            font-weight: 600;
          }
          .cent {
            width: 100%;
            margin-top: 14px;
            font-size: 24px;
            font-weight: bold;
            span {
              font-size: 14px;
            }
          }
          .del {
            width: 100%;
            margin-top: 12px;
            color: #9c9c9c;
            text-decoration: line-through;
          }
          .member-tip-text {
            color: #9c9c9c;
            font-size: 12px;
            line-height: 12px;
            margin-top: 12px;
          }
          &.active {
            color: #ff6644;
            border: 1px solid #ff6644;
            background-color: #FFF6F4;
            .text {
              width: 100%;
            }
            .member-tip-text {
              color: #ff6644;
            }
          }
        }
      }
    }
    .rights-item {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 68px;
      margin-top: 24px;
      border-radius: 8px;
      border: 1px solid rgba($color: #3B3F57, $alpha: .2);
      padding: 0 24px;
      box-sizing: border-box;

      .recommend-final-vip-layout {
        height: 22px;
        box-sizing: border-box;
        background: linear-gradient(132deg, #FFF2E2 0%, #E3C8A9 100%);
        border-radius: 10px 0px 10px 0px;
        padding: 0 8px;
        color: #3B3F57;
        font-weight: 500;
        font-size: 12px;
        justify-content: center;
        align-items: center;
        display: flex;
        top: -12px;
        left: -1px;
        position: absolute;
      }
      .intro-wrapper {
        display: flex;
        align-items: center;
        .cube-checkbox {
          padding: 0;
          margin-right: 16px;

          ::v-deep input {
            border: 0.026667rem solid #3B3F57;
          }
          ::v-deep .cube-checkbox-ui::before {
            color: #3B3F57;
          }
          ::v-deep .cube-checkbox-input {
            padding: 0;
          }
          ::v-deep .cube-checkbox-ui {
            margin: 0;
          }
          ::v-deep  .cube-checkbox-label {
            display: none;
          }
        }
        .cube-checkbox_checked {
          ::v-deep .cubeic-square-right {
            color: #3B3F57;
          }
        }
       
        .intro-container {
          .intro-content {
            font-size: 16px;
            .title {
              color: #3B3F57;
              margin-right: 6px;
              font-weight: 500;
            }
            .detail-btn {
              color: #88888A;
              cursor: pointer;
              text-decoration: underline;
            }
          }
          .intro-desc {
            font-size: 12px;
            color: #3B3F57;
            margin-top: 10px;
            line-height: 12px;
          }
        }
      }
      .price-intro {
        display: flex;
        flex-direction: column;
        align-items: center;
        .real-price {
          font-size: 24px;
          color: #404040;
          font-weight: 600;
          margin-bottom: 4px;
          .rmb-symbol {
            font-size: 14px;
          }
        }
        .original {
          width: 44px;
          text-align: center;
          font-size: 16px;
          color: rgba($color: #404040, $alpha: .6);
          text-decoration: line-through;
        }
      }
    }
    .member-text {
      font-size: 12px;
      margin-top: 12px;
      color: #404040;
      .member-type {
        /*font-weight: bold;*/
      }
      .member-adv {
        color: #9c9c9c;
      }
    }
    .special-offer {
      width: 100%;
      height: 40px;
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /*border-bottom: 1px solid #eee;*/
      .no-coupon {
        font-size: 12px;
        color: #9c9c9c;
        display: flex;
        align-items: center;
        /*line-height: 16px;*/
      }
      .use-coupon {
        font-size: 16px;
        font-weight: 400;
      }
    }
    .price-box {
      width: 100%;
      color: #404040;
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      border-top: 1px solid #eee;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      .item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 20px;
      }
    }
    .total-price {
      width: 100%;
      height: 20px;
      margin-top: 17px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 14px;
      color: #606060;
      .money {
        font-size: 20px;
        color: #ff4c42;
      }
    }
    .member-equity-title {
      font-size: 16px;
      color: #404040;
      margin-bottom: 16px;
      font-weight: 450;
      margin-top: 24px;
    }
    .member-equity {
      width: 327px;
      //height: 268px;
      flex-wrap: wrap;
      /*background: url("https://files.wondercv.com/m/buyMember/member_normal1.png") no-repeat;*/
      /*background-size: 100% 100%;*/
      //background: url("https://files.wondercv.com/m/buyMember/member_super2.png") no-repeat;
      //background-size: 100% 100%;
      .member-item {
        width: 33%;
        flex-direction: column;
        align-items: center;
        position: relative;
        .member-item-img {
          width: 48px;
          height: 48px;
          object-fit: contain;
        }
        .tips {
          width: 28px;
          height: 12px;
          position: absolute;
          top: 12px;
          right: 10px;
        }
        .desc-title {
          color: #404040;
          font-size: 14px;
        }
        .desc-description {
          color: #9c9c9c;
          font-size: 10px;
          margin-top: 5px;
        }
      }
      .opacity-text {
        opacity: 0.5;
      }
    }
    /*.member-equity-super{*/
    /*  background: url("https://files.wondercv.com/m/buyMember/member_super1.png") no-repeat;*/
    /*  background-size: 100% 100%;*/
    /*}*/
    .member-explain {
      width: 100%;
      height: auto;
      margin-top: 24px;
      font-size: 12px;
      color: #909090;
      .title {
        font-size: 16px;
        color: #404040;
        margin-bottom: 16px;
        font-weight: 450;
      }
      .item {
        line-height: 24px;
      }
    }
  }
  .member-footer {
    width: 100%;
    height: 70px;
    position: fixed;
    left: 0;
    bottom: 0;
    //background: url("https://files.wondercv.com/m/buyMember/member-footer.png") no-repeat;
    background-color: #fff;
    //background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    //border-top: 1px solid #eee;
    .submit-btn {
      width: 329px;
      height: 46px;
      border-radius: 23px;
      background-color: #ff6644;
      cursor: pointer;
      text-align: center;
      line-height: 46px;
      color: #fff;
      font-size: 16px;
    }

    .positon-ab {
      position: absolute;
      top: -35px;
      height: 28px;
      background: #FF6644;
      border-radius: 6px;
      font-size: 12px;
      text-align: center;
      line-height: 28px;
      left: 50%;
      transform: translateX(-50%);
      padding: 0 10px;
      .triangle{
        position: absolute;
        top: 21px;
        left: 48%;
        width: 11px;
        height: 11px;
        background: #FF6644;
        transform: rotate(45deg);
        border-radius: 2px;
      }
    }
  }
  .content {
    width: 80vw;
    padding: 0 22px 24px;
    border-radius: 8px;
    background-color: $color-light;
    img {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      margin-top: -28px;
      margin-bottom: 16px;
    }
    .title {
      color: $color-title;
      font-size: $font-size-large-x;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .message {
      color: $color-title;
      font-weight: 400;
      text-align: center;
      line-height: 20px;
      margin-bottom: 14px;
      .high-light {
        color: #027aff;
      }
    }
    .description {
      width: 100%;
      padding: 16px 18px 16px 30px;
      background-color: #fff7f7;
      border-radius: 8px;
      color: $color-dark-gray;
      margin-bottom: 24px;
      li {
        line-height: 24px;
        list-style-position: inside;
      }
    }
    button {
      width: 200px;
      height: 38px;
      border-radius: 21px;
      margin-bottom: 16px;
      span {
        font-weight: 400;
        font-size: $font-size-medium;
      }
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
    .pay-footer {
      font-size: 13px;
      color: #9c9c9c;
      font-weight: 400;
    }
  }

  .member-privilege {
    display: inline-block;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #53320f;
    line-height: 10px;
    padding: 3px 6px;
    border-radius: 8px;
    background: linear-gradient(90deg, #ecd0a6 0%, #d2a971 100%);
    margin-left: 4px;
  }

  .member-color {
    color: #ffdf8b !important;
  }

  .privilege-box {
    width: 100%;
    padding: 32px 24px 24px;

    .privilege-box-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #404040;
      line-height: 18px;
      margin-bottom: 32px;
    }

    .privilege-box-list {
      margin-bottom: 32px;

      .privilege-box-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #404040;
        line-height: 14px;
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .privilege-box-btn {
      width: 100%;
      padding: 13px 0;
      font-size: 16px;
      background: #ff6644;
      border-radius: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      text-align: center;
    }
  }

  .rights-detail-image {
    width: 300px;
    object-fit: contain;
    border-radius: 8px;
  }
}
</style>
